
export default {
  name: 'SortCategory',
  // eslint-disable-next-line vue/require-prop-types
  props: ['dataFilter', 'buttonLoadMore', 'limit', 'textValue', 'textName', 'keyFilter', 'data', 'valueSelect'],
  data() {
    return {
      listData: [],
      listValue: [],
      showListFilter: true,
      loadMore: false
    }
  },
  methods: {
    resetValidate(ref) {
      this.$refs.accountForm.fields.find((f) => f.prop === ref).clearValidate()
      this.accountForm.errors[ref] = ''
    },
    checkShow(index) {
      if (this.buttonLoadMore !== true) return true
      if ((this.loadMore === false) && (index >= this.limit)) return false
      return true
    },
    changeData(value) {
      if (value === this.valueSelect) {
        this.$emit('change', '')
        return
      }
      this.$emit('change', value)
    }
  }
}
